<template>
    
    <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                     <div class="d-flex align-items-center justify-content-between welcome-content mb-3">
                         <div class="card card-block card-stretch card-transparent">
                            <div class="card-header d-flex justify-content-between pb-0">
                                <div class="header-title">
                                    <h4 class="card-title">Common Files</h4>
                                    <button @click="downloadAll(common_link)">Test me!</button>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
            <div class="icon i-list">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card card-block card-stretch card-height">
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table mb-0 table-borderless tbl-server-info">
                                    <thead>
                                        <tr>
                                            <th scope="col">File Name</th>
                                            <th scope="col">File Type</th>
                                            <th scope="col">Last Update</th>
                                            <th scope="col">File Size</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="file in common" v-bind:key="file.id">
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <!-- <div class="mr-3">
                                                         <a :href="list.url"><img :src="list.image" class="img-fluid avatar-30" alt="image1"></a>
                                                    </div> -->
                                                  <!-- <template>
                                                      {{file.name}}
                                                    </template> -->
                                                    <template>
                                                      <!-- <a :data-title="file.name" :data-url="`http://localhost:3000/download?name=demo.pdf`" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal > -->
                                                      <a :data-title="file.name" :data-url="file.url" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal >
                                                        <span style="color:#535F6B;">{{file.name}}</span>
                                                       </a>
                                                    </template>
                                                </div>
                                            </td>
                                            <td>{{file.extension}}</td>
                                            <td>{{file.modified_date}}</td>
                                            <td>{{file.file_size}}</td>
                                            <td><a :href="file.url" download>Download</a></td>
                                            <td>{{file.loc}}</td>
                                            
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="show_merchant" class="row">
                <div class="col-lg-12">
                     <div class="d-flex align-items-center justify-content-between welcome-content mb-3">
                         <div class="card card-block card-stretch card-transparent">
                            <div class="card-header d-flex justify-content-between pb-0">
                                <div class="header-title">
                                    <h4 class="card-title">Merchant Files</h4>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
            <div  v-show="show_merchant" class="icon i-list">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card card-block card-stretch card-height">
                            <div class="card-body">
                                <div class="table-responsive">
                                    <table class="table mb-0 table-borderless tbl-server-info">
                                    <thead>
                                        <tr>
                                            <th scope="col">File Name</th>
                                            <th scope="col">File Type</th>
                                            <th scope="col">Last Update</th>
                                            <th scope="col">File Size</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="file in merchant" v-bind:key="file.id">
                                            <td>
                                                <div class="d-flex align-items-center">
                                                    <template>
                                                      <!-- <a :data-title="file.name" :data-url="`http://localhost:3000/download?name=demo.pdf`" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal > -->
                                                      <a :data-title="file.name" :data-url="`http://localhost:3000/merchant/download?name=GPK_demo.pdf&merchant=GPK`" @click="$root.$emit('bv::show::modal', 'viewer-modal', $event.target)" v-b-modal.viewer-modal >
                                                        <span style="color:#535F6B;">{{file.name}}</span>
                                                       </a>
                                                    </template>
                                                </div>
                                            </td>
                                            <td>{{file.extension}}</td> 
                                            <td>{{file.modified_date}}</td>
                                            <td>{{file.file_size}}</td>  
                                        </tr>
                                    </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
</template>

<script>
import Vue from 'vue';
import axios from 'axios'
import VueAxios from 'vue-axios'
const URL = require("../../../../config");
Vue.use(VueAxios, axios)

export default {
    
    name:'Files',
    data(){
        return{
            data:true,
            folder:[],
            common:[],
            merchant:[],
            common_link:[],
            show_merchant: false
                     
        }
    },
    async mounted()
    {
        let user = JSON.parse(localStorage.getItem("user"));
        console.log(user.merchant_code)
        let response = await Vue.axios.get(URL.api.URL+'/api/mediaPack?merchant=' + user.merchant_code)
        this.folder = response.data.folder
        this.common = response.data.common_file
        this.merchant = response.data.merchant_file
        this.link = response.data
        console.log(this.common)
        console.log(this.merchant)
        if (!this.merchant) {
            this.show_merchant = false
            
        } else {
            this.show_merchant = true
        }
        this.common.forEach(element => {
            var url = element.url
            this.common_link.push(url)
            
        });
        console.log(this.common_link)
    },
    methods:{
        downloadAll(urls) {
            console.log(urls)
            var link = document.createElement('a');

            link.setAttribute('download', null);
            link.style.display = 'none';

            document.body.appendChild(link);
            console.log(urls.length)

            for (var i = 0; i < urls.length; i++) {
                console.log(urls[i])
                link.setAttribute('href', urls[i]);
                console.log(link.setAttribute('href', urls[i]))
                link.click();
            }
            document.body.removeChild(link);
        }
    },
}
</script>